import * as React from 'react';
import {PersonRole} from '@models/person-role';
import {FormattedMessage, FormattedHTMLMessage, FormattedDate, FormattedTime, injectIntl, intlShape} from 'react-intl';
import {Divider, Modal, Table, Button, Avatar} from 'antd';
import Message from "@constants/message";
import PersonRoleForm from "@components/person-roles/Form";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {PaginationDefaultParams} from "../custom/Paginator";
import {NavLink} from "react-router-dom";


type Props = {
  data: PersonRole[],
  loading: boolean,
  deleteFn: (item: PersonRole) => void;
  intl: intlShape.isRequired
  currentPage: number
};


const PersonRolesTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn, intl} = props;
  const {formatMessage} = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  
  const deleteTag = (item: PersonRole): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete,
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete",
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel",
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item),
    });
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'index',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      dataIndex: 'icon_image',
      key: 'icon_image',
      render: (a, record) => <Avatar shape="circle"
                                     size="small"
                                     src={record.icon_image ? record.icon_image.path : null}
                                     icon="reddit"/>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      width: 150,
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 120,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date, record) => <FormattedDateTime date={date}/>
    },
    {
      title: '',
      key: 'actions',
      width: 90,
      dataIndex: 'actions',
      render: (text, record) => (
        <span>
          <NavLink to={`/people/roles/${record.id}/edit`}>
              <Button type="link" size={`small`}>
                <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
              </Button>
          </NavLink>

          <Divider type="vertical" size={`small`}/>

          <Button type="link" className={`danger`} onClick={() => deleteTag(record)}>
            <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
          </Button>
        </span>
      ),
    },
  ];
  
  
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
  
};

export default injectIntl(PersonRolesTable);